module.exports = __webpack_public_path__ + "static/media/dancers-red.574a5801.png";